import { Typography } from "@mui/material";
const Register = () => {
  return <Typography>Redirecting to registration page...</Typography>;
};

export default Register;
